// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { KeyValueGroup } from './GroupsImport';
import { OptionContract } from '@shared/utils/Instruments/OptionContract';
import { PriceLimitMeasure } from '@shared/utils/Instruments/PriceLimitMeasure';
export class OptionContractGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.OPTION_CONTRACT_GROUP, null, pfixFieldSet);
    }
    getGroupContractID() {
        return this.GetValue(FieldsFactory.FIELD_CONTRACT_ID);
    }
    getStrikeContractID() {
        return this.GetValue(FieldsFactory.FIELD_OPTION_CONTRACT_ID);
    }
    getStrikeVersion() {
        return this.GetValue(FieldsFactory.FIELD_STRIKE_VERSION);
    }
    getStrikeTicker() {
        return this.GetValue(FieldsFactory.FIELD_NAME);
    }
    getStrikePrice() {
        return this.GetValue(FieldsFactory.FIELD_STRIKE_PRICE);
    }
    // возвращает call (0) или put (1)
    getPutOrCall() {
        return this.GetValue(FieldsFactory.FIELD_OPTION_TYPE);
    }
    getLowLimit() {
        return this.GetValue(FieldsFactory.FIELD_PRICE_LOW_LIMIT);
    }
    getHighLimit() {
        return this.GetValue(FieldsFactory.FIELD_PRICE_HI_LIMIT);
    }
    getPriceLimitMeasure() {
        const val = this.GetValue(FieldsFactory.FIELD_PRICE_LIMIT_MESURE);
        return val === null ? PriceLimitMeasure.DISABLE : val;
    }
    getDescription() {
        return this.GetValue(FieldsFactory.FIELD_DESCRIPTION);
    }
    getTradeSessionStatusId() {
        return this.GetValue(FieldsFactory.FIELD_TRADE_SESSION_STATUS_ID);
    }
    getExchangeSessionName() {
        return this.GetValue(FieldsFactory.FIELD_EXCHANGE_SESSION_NAME);
    }
    getInstrumentTradableID() {
        return this.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    getMinLot() {
        return this.GetValue(FieldsFactory.FIELD_MINIMAL_LOT);
    }
    getMaxLot() {
        return this.GetValue(FieldsFactory.FIELD_MAX_LOT);
    }
    getMaxLotInCash() {
        return this.GetValue(FieldsFactory.FIELD_MAX_LOT_IN_CASH);
    }
    getISIN() {
        return this.GetValue(FieldsFactory.FIELD_ISIN);
    }
    getTradingMode() {
        return this.GetValue(FieldsFactory.FIELD_TRADE_MODE);
    }
    getHighLimitFrontEndValidationEnabled() {
        return this.GetValue(FieldsFactory.FIELD_HI_PRICE_LIMIT_ENABLED);
    }
    getLowLimitFrontEndValidationEnabled() {
        return this.GetValue(FieldsFactory.FIELD_LOW_PRICE_LIMIT_ENABLED);
    }
    getExtFields() {
        const extFields = this.GetGroups(FieldsFactory.KEY_VALUE_GROUP, KeyValueGroup);
        if (extFields.length === 0) {
            return {};
        }
        const result = {};
        const len = extFields.length;
        for (let i = 0; i < len; i++) {
            const kv = extFields[i];
            result[kv.getKey()] = kv.getValue();
        }
        return result;
    }
    // новая схема OPTION_CONTRACT_GROUP(57) приходит в InstrumentMessage (2)
    // это сделано так, потому что при расположении группы по старой схеме
    // происходило переполнение EXPIRATION_DATE_GROUP_NAME(26) (#57391)
    static GetOptionContractGroup(fs, contractID = null) {
        const ocGroupList = fs.GetGroups(FieldsFactory.OPTION_CONTRACT_GROUP, OptionContractGroup);
        const ocList = [];
        const len = ocGroupList.length;
        for (let i = 0; i < len; i++) {
            const ocg = ocGroupList[i];
            const oc = new OptionContract(contractID === null ? ocg.getGroupContractID() : contractID, ocg.getStrikeContractID(), ocg.getStrikeTicker(), ocg.getStrikeVersion(), ocg.getStrikePrice(), ocg.getPutOrCall());
            oc.LowLimit = ocg.getLowLimit();
            oc.HighLimit = ocg.getHighLimit();
            oc.PriceLimitMeasure = ocg.getPriceLimitMeasure();
            oc.Description = ocg.getDescription();
            oc.ExtFields = ocg.getExtFields();
            oc.TradeSessionStatusId = ocg.getTradeSessionStatusId();
            oc.ExchangeSessionName = ocg.getExchangeSessionName();
            oc.InstrumentTradableID = ocg.getInstrumentTradableID();
            oc.ISIN = ocg.getISIN();
            oc.TradingMode = ocg.getTradingMode();
            oc.minLot = ocg.getMinLot();
            oc.maxLot = ocg.getMaxLot();
            oc.maxLotInCash = ocg.getMaxLotInCash();
            oc.IsHighLimitFrontEndValidationEnabled = ocg.getHighLimitFrontEndValidationEnabled();
            oc.IsLowLimitFrontEndValidationEnabled = ocg.getLowLimitFrontEndValidationEnabled();
            ocList.push(oc);
        }
        return ocList;
    }
    // мержим контракты пришедшие по старой схеме, с контрактами, пришедшими, по новой схеме
    static MergeOptionContractGroup(fs, insDateSettingsArray) {
        const optionContractArr = OptionContractGroup.GetOptionContractGroup(fs);
        for (let i = 0, len = insDateSettingsArray.length; i < len; i++) {
            OptionContract.MergeOptionContractGroup(insDateSettingsArray[i], optionContractArr);
        }
    }
}
